/*eslint-disable*/
import React, { useContext, useEffect, useRef, useState } from "react"
import authContext from "../../context/AuthContext"
import JAlert from "../../components/smallComponent/jAlert"
import InputAdornment from "@material-ui/core/InputAdornment"
import {
  Apartment,
  ChangeHistory,
  CompareArrows,
  Delete,
  DoubleArrow,
  DoubleArrowTwoTone,
  PlusOne,
  TrackChanges,
} from "@material-ui/icons"
import FormControl from "@material-ui/core/FormControl"
import InputLabel from "@material-ui/core/InputLabel"
import Select from "@material-ui/core/Select"
import MenuItem from "@material-ui/core/MenuItem"
import { GridLoader } from "react-spinners"

// core components
import GridContainer from "components/Grid/GridContainer.js"
import GridItem from "components/Grid/GridItem.js"
import CustomInput from "components/CustomInput/CustomInput.js"
import Button from "components/CustomButtons/Button.js"
import Card from "components/Card/Card.js"
import CardHeader from "components/Card/CardHeader.js"
import CardText from "components/Card/CardText.js"
import CardBody from "components/Card/CardBody.js"

import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle"
import stylesExtended from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js"
import buttonStyles from "assets/jss/material-dashboard-pro-react/views/buttonsStyle.js"

import ImageUpload from "../../components/CustomUpload/ImageUpload"
import customSelectStyle from "../../assets/jss/material-dashboard-pro-react/customSelectStyle"
import customCheckboxRadioSwitch from "../../assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch"
import Favorite from "@material-ui/icons/Favorite"
import { makeStyles } from "@material-ui/core/styles"
import config from "../../config"
import {
  addGroup,
  changeGroupName,
  getGroups,
  saveGroup,
} from "../../api/groupAction"
import { getMPNameFromLocalStorage } from "../../services/AuthApi"
import Add from "@material-ui/icons/Add"

const localStyles = {
  infoText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "center",
  },
  inputAdornmentIcon: {
    color: "#555",
  },
  choiche: {
    textAlign: "center",
    cursor: "pointer",
    marginTop: "20px",
  },
  ...customSelectStyle,
  ...customCheckboxRadioSwitch,

  modernCardBody: {
    marginTop: 60,
    paddingTop: 20,
    paddingBottom: 40,
    borderRadius: 12,
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.4)",
    // Centering the card and it's inside component
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
    flexDirection: "column",
    color: "#fff",

    // Note : Responsive design centered
    marginLeft: "25%",
    marginRight: "25%",
    marginBottom: "25%",
    "@media (max-width: 600px)": {
      width: "90%",
      marginLeft: "5%",
      marginRight: "5%",
    },
    "@media (max-width: 960px)": {
      width: "80%",
      marginLeft: "10%",
      marginRight: "10%",
    },
    "@media (min-width: 960px)": {
      width: "50%",
      marginLeft: "25%",
      marginRight: "25%",
    },
  },
}

const disabledStyle = {
  disabledBack: {
    backgroundColor: "red",
  },
}

const useDisabledStyle = makeStyles(disabledStyle)
const useButtonStyles = makeStyles(buttonStyles)
const useLocalStyle = makeStyles(localStyles)
const useStyles = makeStyles(styles)
const useStylesExtended = makeStyles(stylesExtended)

const BASE_URL = config.BASE_URL

const label = {
  formTitle: "Mon compte",
  groupLabel: "Liste des groupes",
  addGroupLabel: "Ajouter un groupe",
  modifyGroupLabel: "Modifier le nom d'un groupe",
  mainTitle: "Gestion des groupes",
  subTitle: "Ajouter, modifier ou supprimer des groupes pour votre société.",
  subTitleModification: "Modifier le nom d'un groupe",
}

const groupExample = [
  {
    name: "Region Parisienne",
    id: 1,
  },
  {
    name: "Region Lyonnaise",
    id: 2,
  },
  {
    name: "Region Marseillaise",
    id: 3,
  },
  {
    name: "Region Bordelaise",
    id: 4,
  },
]

/**
 * Note : Ajouter de nouveaux groupes, modifier les groupes existants
 * @param props
 * @constructor
 */
export const Group = (props) => {
  const { mpId, mpEmail, mpRole } = useContext(authContext)
  const [mpName, setMpName] = useState(getMPNameFromLocalStorage())
  const [newGroupName, setNewGroupName] = useState("")
  const [modName, setModName] = useState({ name: "", gid: undefined })
  const [groups, setGroups] = useState(groupExample)
  const [loading, setLoading] = useState(false)
  const classes = useStyles()
  const [showAlert, setShowAlert] = useState(false)
  const [typeAlert, setTypeAlert] = useState("success")
  const [alertMessageBox, setAlertMessageBox] = useState(
    "Bravo, vos modifications ont été enregistrées."
  )
  const classesExtended = useStylesExtended()
  const disabled = useDisabledStyle()
  const classesLocal = useLocalStyle()
  const buttonClasses = useButtonStyles()

  /**
   *
   * @param group
   * @param gid
   * @returns {*|undefined}
   */
  const getNameByGid = (group, gid) =>
    group.find((r) => r.gid === gid)?.name || undefined

  function updateNameByGid(gid, newName) {
    const group = groups.find((r) => r.gid === gid)
    console.log("Updating group name:", gid, newName, group)
    if (group) {
      group.name = newName
      return true // modification réussie
    }
    return false // aucun objet trouvé
  }

  function updateObjectInArray(array, id, key, newValue, idKey = "gid") {
    return array.map((item) =>
      item[idKey] === id ? { ...item, [key]: newValue } : item
    )
  }

  /**
   * Note : Fetching the groups for the current user
   */
  useEffect(() => {
    if (mpId && mpEmail) {
      getGroups(mpId)
        .then((response) => {
          console.log("Fetched groups:", response.data)
          if (response && response.data) {
            setGroups(response.data.data)
          }
        })
        .catch((error) => {
          console.error("Error fetching groups:", error)
        })
    }
  }, [mpId, mpEmail])

  /**
   * Note : Alert manager
   */
  const showInfo = () => {
    setShowAlert(!showAlert)
  }
  /**
   * Note : Handle the change of group name
   * @param e
   */
  const handleChangeGroupName = (e) => {
    e.preventDefault()
    let gIdTarget = e.target.value
    let st = getNameByGid(groups, gIdTarget)
    if (st) {
      changeGroupName(gIdTarget, st)
        .then((response) => {
          console.log("Group name changed successfully:", response.data)
          setTypeAlert("success")
          setAlertMessageBox("Le nom du groupe a été modifié avec succès.")
          showInfo()
        })
        .catch((error) => {
          console.error("Error changing group name:", error)
          setTypeAlert("danger")
          setAlertMessageBox(
            "Une erreur est survenue lors de la modification du nom du groupe."
          )
          showInfo()
        })
      setModName({ name: st, gid: e.target.value })
    } else {
      setModName({ name: "", gid: undefined })
    }
  }

  const handleAddGroup = (_name) => {
    setNewGroupName(_name)
    if (_name && _name.trim() !== "") {
      addGroup(mpId, _name).then((response) => {
        console.log("Group added successfully:", response.data)
        setTypeAlert("success")
        setAlertMessageBox("Le groupe a été ajouté avec succès.")
        showInfo()
        // Update the groups state with the new group
        const newGroup = {
          gid: response.data.gid, // Assuming the response contains the new group's ID
          name: _name,
        }
      })
    }
  }
  const handleModNameInput = (_name) => {
    console.log("Modifying group name:", _name, modName)
    setModName((prev) => ({
      ...prev,
      name: _name,
    }))
  }

  const handleUpdateGroupName = (_item) => {
    console.log("inside mode name ", _item, typeof _item)
    let st = updateObjectInArray(groups, _item.gid, "name", _item.name)
    setGroups(st)
  }

  const handleDeleteGroup = (gid) => {}

  /**
   * ###############################################################################
   * Saving the data                      handleRegister
   * ###############################################################################
   * */
  const handleRegister = () => {
    const groupData = {
      mpId: mpId,
      email: mpEmail,
      role: mpRole,
      groups: groups,
    }

    // saveGroup(groupData)
    //   .then((response) => {
    //     if (response && response.data) {
    //       console.log("Group saved successfully:", response.data)
    //     }
    //   })
    //   .catch((error) => {
    //     console.error("Error saving group:", error)
    //   })
  }

  return (
    <div>
      {!loading ? (
        <GridContainer>
          {/*Large Form*/}
          <JAlert
            type={typeAlert}
            show={showAlert}
            localStatus={showInfo}
            titleText={alertMessageBox}
            subTitleText={
              typeAlert === "success " ? "...et elles sont déjà actives." : ""
            }
          />
          <GridItem xs={12}>
            <Card>
              <CardHeader color="rose" text>
                <CardText color="rose">
                  <h4 className={classes.cardTitle}>
                    {mpName
                      ? mpName + " - Gestion des groupes"
                      : "Nom de votre Société"}
                  </h4>
                </CardText>
              </CardHeader>
              <CardBody className={classesLocal.modernCardBody}>
                <form>
                  {/** ################################################ **/}
                  {/** #######              Title               ####### **/}
                  {/** ################################################ **/}
                  <div style={{ textAlign: "center", marginTop: 40 }}>
                    <h4 className={classes.cardTitle} style={{ color: "#000" }}>
                      {label.mainTitle}
                    </h4>
                    <h6
                      style={{
                        marginBottom: "20px",
                        fontSize: "0.8rem",
                        color: "#000",
                      }}
                    >
                      {label.subTitle}
                    </h6>
                  </div>
                  <GridContainer
                    container
                    spacing={1}
                    direction="row"
                    alignItems="center"
                  >
                    <GridItem xs={12} sm={12}>
                      <CustomInput
                        labelText={label.addGroupLabel}
                        id="name"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <Add
                                style={{
                                  color: "#0d143a",
                                  borderRadius: 12,
                                  backgroundColor: "#f0f0f0",
                                  padding: 5,
                                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                  cursor: "pointer",
                                }}
                              />
                            </InputAdornment>
                          ),
                          type: "text",
                          value: newGroupName,
                          onChange: (e) => {
                            handleAddGroup(e.target.value)
                          },
                        }}
                      />
                      {/** ################################################ **/}
                      {/** #######          Sub-Title               ####### **/}
                      {/** ################################################ **/}
                      <div style={{ textAlign: "center", marginTop: 40 }}>
                        <h6
                          style={{
                            fontSize: "0.8rem",
                            color: "#000",
                          }}
                        >
                          {label.subTitleModification}
                        </h6>
                        <p style={{ color: "#000", fontSize: "0.7rem" }}>
                          (Sélectionner un groupe pour le supprimer ou le modifier
                          avec les boutons ci-dessous)
                        </p>
                      </div>
                      {/** ################################################ **/}
                      {/** ################  Group List    ################ **/}
                      {/** ################################################ **/}
                      <FormControl
                        fullWidth
                        className={classesExtended.selectFormControl}
                      >
                        <InputLabel
                          htmlFor="group-list-select"
                          className={classesExtended.selectLabel}
                          style={{ marginLeft: 0 }}
                        >
                          {label.groupLabel}
                        </InputLabel>

                        {groups ? (
                          <Select
                            value={groups.name}
                            onChange={handleChangeGroupName}
                            MenuProps={{ className: classesExtended.selectMenu }}
                            classes={{ select: classesExtended.select }}
                            inputProps={{
                              name: "groupList",
                              id: "group-list-select",
                            }}
                          >
                            {groups.map((group) => {
                              return (
                                <MenuItem
                                  id={group.gid}
                                  key={group.gid}
                                  classes={{
                                    root: classesExtended.selectMenuItem,
                                    selected:
                                      classesExtended.selectMenuItemSelectedMultiple,
                                  }}
                                  value={group.gid}
                                >
                                  {group.name}
                                </MenuItem>
                              )
                            })}
                          </Select>
                        ) : null}
                      </FormControl>

                      {/** ################################################ **/}
                      {/** ################  Button action ################ **/}
                      {/** ################################################ **/}
                      <div
                        style={{
                          textAlign: "center",
                          flexDirection: "row",
                          marginTop: 20,
                        }}
                      >
                        <Button
                          color="success"
                          round
                          onClick={() => {
                            console.log("Saving group data:")
                          }}
                        >
                          <Favorite className={buttonClasses.icons} /> Modifier le
                          nom
                        </Button>
                        <Button
                          color="warning"
                          round
                          onClick={() => {
                            console.log("Saving group data:")
                          }}
                        >
                          <Delete className={buttonClasses.icons} /> Supprimer
                        </Button>
                      </div>
                      <CustomInput
                        visible={modName.gid !== undefined}
                        labelText={label.modifyGroupLabel}
                        id="name"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <CompareArrows
                                onClick={() => {
                                  console.log("Modifying group name: ->", modName)
                                  handleUpdateGroupName(modName)
                                }}
                                style={{
                                  color: "#0d143a",
                                  borderRadius: 12,
                                  backgroundColor: "#f0f0f0",
                                  padding: 5,
                                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                  cursor: "pointer",
                                }}
                              />
                            </InputAdornment>
                          ),
                          type: "text",
                          value: modName.name,
                          onChange: (e) => {
                            handleModNameInput(e.target.value)
                          },
                        }}
                      />
                    </GridItem>
                  </GridContainer>
                </form>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      ) : (
        <div className={disabled.disabledBack}>
          <GridLoader
            color="#3f4850"
            loading={loading}
            size={50}
            css={`
              position: absolute;
              display: block;
              z-index: 999;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            `}
          />
          <JAlert
            type="success"
            show={showAlert}
            localStatus={showInfo}
            titleText="Bravo, vos modifications ont été enregistrées."
            subTitleText="...et elles sont déjà actives."
          />
        </div>
      )}
    </div>
  )
}
